import React, { useEffect } from "react";
import "../AboutUs/TheCompany.css";
import Footer from "../../Components/Navigation/Footer";
import Navigation from "../../Components/Navigation/Navigation";
import GreenStamp from "../../Assets/Images/AboutUs/zen-stamp.svg";
import ZenImages from "../../Assets/Images/AboutUs/sales.jpeg";
import Banner from "../../Components/Banner";
import WhiteBuilding from "../../Assets/Images/AboutUs/zen-big-buildings.jpeg";

function TheCompany() {
  useEffect(() => {
    document.title = "The Company | Zen Homes";
  }, []);
  return (
    <div className="aboutUsContainer">
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner title="About The Company" backgroundImage={WhiteBuilding} />
      <div className="meetTeamContainer">
        <div className="intro">
          <p>
            Zen Homes was founded in 2021 by two friends who shared a common
            vision of starting a business together. With an extensive local
            knowledge of North London and over 25 years of combined experience
            in estate agency, their dream became a reality.
          </p>
          <br />
          <p>
            Driven by a passion for the property industry and a commitment to
            providing exceptional customer service and client interaction, they
            recognised that this was the perfect time to elevate their
            aspirations and demonstrate what a truly genuine, sincere, honest,
            and transparent estate agency should be.
          </p>
          <br />
          <p>
            Both founders possess a deep understanding of North London, with one
            having an exceptional knowledge of the Haringey borough and the
            other being well-versed in the Enfield borough. This geographical
            expertise made it logical to establish their office in a central
            location between the two boroughs, allowing them to cover a broad
            area and cater to the diverse market demands in both Haringey and
            Enfield.
          </p>
          <br />
          <p>
            They are dedicated to assisting clients at every stage of the
            selling and renting process, providing support and guidance along
            the way and an unparalleled approach to refreshing Estate Agency.
          </p>
          <img src={GreenStamp} />
        </div>
      </div>
      <div className="ctaContainer">
        <div className="ctaImage">
          <img src={ZenImages} alt=" sales building" />
        </div>
        <div className="ctaInfo">
          <h1 className="ctaHeading">
            Supported by a strong, well-established branch
          </h1>
          <p className="ctaText">
            With a solid foundation and years of industry expertise, our agency
            is built on trust, reliability, and a deep understanding of the
            local market. We provide unparalleled support, ensuring seamless
            property transactions with professionalism and integrity.
          </p>
          <div className="ctaButtons">
            <button className="ctaButton1">
              <a href="/sales">View Our Sales Properties</a>
            </button>
            <br />
            <button className="ctaButton2">
              <a href="/book-valuation">Book a Valuation</a>
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TheCompany;
